import Vue from 'vue';
import Vuex from 'vuex';
import accounts from './modules/account';
import articles from './modules/article';
import app from './modules/app';
import auth from './modules/auth';
import beliefStatements from './modules/belief_statement';
import channels from './modules/channel';
import collections from './modules/collection';
import events from './modules/event';
import eventContacts from './modules/event_contact';
import eventPackages from './modules/event_package';
import eventRegistrations from './modules/event_registration';
import episodes from './modules/episode';
import forms from './modules/form';
import formBlocks from './modules/form_block';
import formFields from './modules/form_field';
import locations from './modules/location';
import media from './modules/media';
import members from './modules/member';
import ministries from './modules/ministry';
import ministryRoles from './modules/ministry_role';
import orders from './modules/orders';
import pages from './modules/page';
import services from './modules/services';
import speakers from './modules/speaker';
import staffMembers from './modules/staff_members';
import tags from './modules/tag';
import users from './modules/user';
import waivers from './modules/waiver';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    accounts,
    articles,
    app,
    auth,
    belief_statements: beliefStatements,
    channels,
    collections,
    events,
    event_contacts: eventContacts,
    event_packages: eventPackages,
    event_registrations: eventRegistrations,
    episodes,
    forms,
    form_blocks: formBlocks,
    form_fields: formFields,
    locations,
    media,
    members,
    ministries,
    ministry_roles: ministryRoles,
    orders,
    pages,
    services,
    speakers,
    staff_members: staffMembers,
    tags,
    users,
    waivers,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js